/**
 * Wool and Magic — correctifs panier (15/10/2026)
 *
 * 1. Robustesse du rafraîchissement du panier.
 *    Dawn (assets/cart.js) rafraîchit quatre blocs après chaque modification du
 *    panier : lignes, compteur d'en-tête (« cart-icon-bubble »), zone
 *    d'accessibilité et pied de panier (le total). L'en-tête de la boutique est
 *    personnalisé et ne contient pas d'élément « cart-icon-bubble » : cart.js
 *    tombait sur un élément inexistant, levait une erreur à la 2e étape sur 4 et
 *    n'atteignait jamais le pied de panier. Résultat visible par le client : la
 *    ligne supprimée disparaît, le total reste faux et un message d'erreur
 *    s'affiche alors que le serveur a bien travaillé.
 *    On filtre ici les blocs absents de la page, sans modifier cart.js.
 *
 * 2. Compteur du panier dans l'en-tête.
 *    wool-magic-entete.liquid met son compteur à jour sur l'événement
 *    « cart:refresh », que Dawn n'émet jamais. On relaie l'événement standard de
 *    Dawn (PUB_SUB_EVENTS.cartUpdate) vers celui-là.
 *
 * Ce fichier est chargé en « defer » depuis layout/theme.liquid, donc avant
 * assets/cart.js qui est chargé par la section du panier : on attend donc que
 * l'élément <cart-items> soit défini avant de le corriger.
 */

(function () {
  function filtrerBlocsAbsents(ClasseCartItems) {
    if (!ClasseCartItems || ClasseCartItems.prototype.wmBlocsFiltres) return;

    var origine = ClasseCartItems.prototype.getSectionsToRender;
    if (typeof origine !== 'function') return;

    ClasseCartItems.prototype.getSectionsToRender = function () {
      return origine.call(this).filter(function (bloc) {
        return document.getElementById(bloc.id) !== null;
      });
    };
    ClasseCartItems.prototype.wmBlocsFiltres = true;
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-items').then(function (Classe) {
      filtrerBlocsAbsents(Classe || customElements.get('cart-items'));
    });
  }

  function relayerVersEntete() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relayerVersEntete, { once: true });
  } else {
    relayerVersEntete();
  }
})();
